<template>
  <div>
    <label >{{ $t('insights.ui.booleans') }}</label>
    <template v-for="(boolean, index) in getBooleansToCount">
      <div class="custom-control custom-checkbox" v-bind:key="'boolean-' + uniqueId + index">
        <input v-model="booleanValues[boolean]"
               @change="setBooleansToConfig"
               :value="true"
               type="checkbox" :id="'boolean-' + uniqueId + index"
               class="custom-control-input"
        >
        <label class="custom-control-label" :for="'boolean-' + uniqueId + index">
          <span>{{  $t('insights.ui.boolean.' + boolean) }}</span>
        </label>
      </div>
    </template>
  </div>
</template>

<script>
import generalMethods from "@/mixins/insights/generalMethods";
import {mapGetters} from "vuex";

export default {
  mixins: [generalMethods],
  name: "BooleansToInclude",
  props: ['editing', 'currentConfig'],
  data() {
    return {
      uniqueId: _.uniqueId(),
      booleanValues: {}
    }
  },
  computed: {
    ...mapGetters('company', ['getConfig']),
    getBooleansToCount() {
      return this.getConfig.booleansToCount;
    }
  },
  methods: {
    setBooleansToConfig() {
      this.config.componentConfig.booleansToCount = this.booleanValues;
      this.emitConfig();
    }
  },
  created(){
    this.config = this.currentConfig;
    if (!this.config.componentConfig.booleansToCount) {
      this.config.componentConfig.booleansToCount = {};
    }

    this.booleanValues = this.config.componentConfig.booleansToCount;
  }

}
</script>

<style scoped>

</style>